/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {floatNumberFormat} from "utils/utility";
import {PackageCategoryEntity} from "types/entities/PackageCategoryEntity";

const InsideContainer = (props: {isCategoryCardVisible: boolean; packageCategoryEntity: PackageCategoryEntity; onClick: () => void}) => {
    const {t} = useTranslation();

    return (
        <div
            className={"flex flex-col xs:flex-row w-full items-center bg-gray-900 text-white justify-center gap-x-6 xs:gap-x-12"}
            style={{
                backgroundImage: "url(/img/package_category/black.webp)",
                backgroundSize: "cover",
            }}
        >
            <div
                className={
                    "cursor-pointer rounded-2xl text-gray-100 text-sm pt-2 pb-2 xs:pt-5 xs:pb-4 capitalize font-semibold px-2 lg:px-4 h-full flex flex-row space-x-3 justify-center items-end"
                }
                id={"PricePerPerson:" + props.packageCategoryEntity.id}
                onClick={props.onClick}
            >
                <div>{t("from")}</div>
                <div className={"flex font-zuume text-gray-200 text-4xl sm:text-5xl xl:text-[45pt] font-bold italic"}>
                    <span className={"-mb-2 sm:-mb-3"}>{floatNumberFormat(props.packageCategoryEntity.price * 100)} CHF</span>
                </div>
                <div className={"PerPerson"}>{t("per person")}</div>
            </div>

            <button
                className={clsx(
                    "ButtonCTA duration-150 transform-gpu",
                    "rounded-2xl hover:drop-shadow-none drop-shadow-[0px_5px_5px_rgba(0,0,0,0.20)]  bg-gradient-to-l from-[#F7C12A] to-[#ED3D34] hover:text-white text-black text-lg sm:text-xl lg:text-2xl xl:text-3xl mb-2 xs:mb-0 py-1.5 xs:py-3 px-3 xs:px-12 font-bold"
                )}
                id={"BookNow:" + props.packageCategoryEntity.id}
                onClick={props.onClick}
            >
                <span>{props.packageCategoryEntity.buttonText}</span>
            </button>
        </div>
    );
};
const CategoryDetailFooterButton = (props: {
    isCategoryCardVisible: boolean;
    packageCategoryEntity: PackageCategoryEntity;
    onClick: () => void;
    isCategoryCardOnTheBottom: boolean;
}) => {
    return (
        <div
            className={clsx(
                "flex flex-col items-center z-20",
                props.isCategoryCardVisible
                    ? "relative"
                    : props.isCategoryCardOnTheBottom
                      ? "absolute bottom-0 left-0 right-0"
                      : "fixed w-screen bottom-0 left-0 right-0"
            )}
        >
            <InsideContainer isCategoryCardVisible={props.isCategoryCardVisible} packageCategoryEntity={props.packageCategoryEntity} onClick={props.onClick} />
        </div>
    );
};

export default CategoryDetailFooterButton;
